import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Membresias from '../components/Membresias/Membresias'
import Miembros from '../components/Miembros/Miembros'

// Función para verificar autenticación
const verificarAutenticacion = (to, from, next) => {
  const logeado = localStorage.getItem('logeado')
  if (!logeado) {
    next({ path: '/login' })
    return
  }
  next()
}

// Función para verificar rol de administrador
const verificarAdmin = (to, from, next) => {
  const rol = localStorage.getItem('rolUsuario')
  if (rol !== 'admin') {
    next({ path: '/miembros' })
    return
  }
  next()
}
import EditarMiembro from '../components/Miembros/EditarMiembro'
import Usuarios from '../components/Usuarios/Usuarios'
import NuevoMiembro from '../components/Miembros/NuevoMiembro'
import NuevoUsuario from '../components/Usuarios/NuevoUsuario'
import EditarUsuario from '../components/Usuarios/EditarUsuario'
import CambiarPassword from '../components/Usuarios/CambiarPassword'
import Pagos from '../components/Pagos/Pagos'
import RegistrarVisita from '../components/Visitas/RegistrarVisita'
import Visitas from '../components/Visitas/Visitas'
import ConfiguracionComponent from '../components/Configuracion/ConfiguracionComponent'
import InicioComponent from '../components/InicioComponent'
import MiPerfil from '../components/Usuarios/MiPerfil'
import Productos from '../components/Productos/Productos'
import Ventas from '../components/Ventas/Ventas'
import Caja from '../components/Caja/Caja.vue'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/components/Usuarios/Login.vue')
    },
    {
      path: '/',
      name: 'InicioComponent',
      component: InicioComponent,
      meta: { requiresAdmin: true },
      beforeEnter: verificarAdmin
    },
    {
      path: '/membresias',
      name: 'Membresias',
      component: Membresias
    },
    {
      path: '/miembros',
      name: 'Miembros',
      component: Miembros
    },
    {
      path: '/nuevo-miembro',
      name: 'NuevoMiembro',
      component: NuevoMiembro
    },
    {
      path: '/editar-miembro/:id',
      name: 'EditarMiembro',
      component: EditarMiembro,
    },
    {
      path: '/usuarios',
      name: 'Usuarios',
      component: Usuarios,
      meta: { requiresAdmin: true },
      beforeEnter: verificarAdmin
    },
    {
      path: '/nuevo-usuario',
      name: 'NuevoUsuario',
      component: NuevoUsuario,
      meta: { requiresAdmin: true },
      beforeEnter: verificarAdmin
    },
    {
      path: '/editar-usuario/:id',
      name: 'EditarUsuario',
      component: EditarUsuario,
    },
    {
      path: '/cambiar-password',
      name: 'CambiarPassword',
      component: CambiarPassword
    },
    {
      path: '/pagos',
      name: 'Pagos',
      component: Pagos
    },
    {
      path: '/registrar-visita',
      name: 'RegistrarVisita',
      component: RegistrarVisita
    },
    {
      path: '/visitas',
      name: 'Visitas',
      component: Visitas
    },
    {
      path: '/configurar',
      name: 'Configurar',
      component: ConfiguracionComponent
    },
    {
      path: '/perfil',
      name: 'MiPerfil',
      component: MiPerfil
    },
    {
      path: '/productos',
      name: 'Productos',
      component: Productos
    },
    {
      path: '/ventas',
      name: 'Ventas',
      component: Ventas
    },
    {
      path: '/caja',
      name: 'Caja',
      component: Caja,
      meta: { requiresAdmin: true },
      beforeEnter: verificarAdmin
    },
  ]
})

// Agregar guardia de navegación global
router.beforeEach((to, from, next) => {
  // Si la ruta no es /login, primero verificar que el usuario esté autenticado
  if (to.path !== '/login') {
    const logeado = localStorage.getItem('logeado')
    if (!logeado) {
      next({ path: '/login' })
      return
    }
  }

  // Verificar meta requiresAdmin en la ruta (o en cualquier ruta anidada)
  const necesitaAdmin = to.matched.some(record => record.meta && record.meta.requiresAdmin)
  if (necesitaAdmin) {
    const rol = localStorage.getItem('rolUsuario')
    if (rol !== 'admin') {
      // Redirigir a una ruta segura para usuarios normales
      next({ path: '/miembros' })
      return
    }
  }

  // Si todo está bien, continuar
  next()
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js